import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PricingModel } from '@app/modules/tf-pricing';
import { FishersciPricingService } from '@app/modules/tf-pricing/services/fishersci-pricing.service';
import { ThermofisherPricingService } from '@app/modules/tf-pricing/services/thermofisher-pricing.service';
import { TfUserDataService } from '@app/modules/tf-user-data';
import { ProductSiteRegionService } from '@app/services/product-site-region.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PriceService {

    constructor(
        private fishersciPricingService: FishersciPricingService,
        private thermofisherPricingService: ThermofisherPricingService,
        private productSiteRegionService: ProductSiteRegionService,
        private userDataService: TfUserDataService
    ) {
    }

    preloadPricingInfo(skus: string[]): void {

        if (this.productSiteRegionService.isThermofisher()) {

            this.userDataService.getUserDetails().subscribe({
                next: (userDetails) => {
                    this.thermofisherPricingService.preloadPricingInfo(skus, userDetails.isLoggedIn);
                },
                error: (e: HttpErrorResponse) => {
                    console.log(e);
                }
            });

        }

        if (this.productSiteRegionService.isFisherSci()) {
            this.fishersciPricingService.preloadPricingInfo(skus);
        }

    }

    getPreloadedPricing(sku: string): Observable<PricingModel> {

        if (this.productSiteRegionService.isThermofisher()) {
            return this.thermofisherPricingService.getPreloadedPricing(sku);
        }

        if (this.productSiteRegionService.isFisherSci()) {
            return this.fishersciPricingService.getPreloadedPricing(sku);
        }

        return null;

    }

    getPricing(sku: string, isLoggedIn: boolean): Observable<PricingModel> {

        if (this.productSiteRegionService.isThermofisher()) {
            return this.thermofisherPricingService.getPricing(sku, isLoggedIn);
        }

        if (this.productSiteRegionService.isFisherSci()) {
            return this.fishersciPricingService.getPricing(sku);
        }

        return null;

    }

    getAnonymousCurrencyCode(): string {

        if (this.productSiteRegionService.isThermofisher()) {
            return this.thermofisherPricingService.getAnonymousCurrencyCode();
        }

        if (this.productSiteRegionService.isFisherSci()) {
            return this.fishersciPricingService.getAnonymousCurrencyCode();
        }

        return null;

    }

}
